import { StatusTag } from 'foundations-components/transitional/components/StatusTag';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { ChangeArrow } from 'foundations-components/transitional/components/ChangeArrow';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DEAL_AMOUNT, DEAL_HISTORY_INFO } from '../../constants/DealHistoryConstants';
import { AmountChangeEvent } from '../../types/api/deals';

/* Badge (with tooltip) that reflects a deal amount's New status */
import { jsx as _jsx } from "react/jsx-runtime";
export const NewDealAmountTag = () => {
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: DEAL_HISTORY_INFO[DEAL_AMOUNT][AmountChangeEvent.NEW].tooltipText
    }),
    children: /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(StatusTag, {
        "data-test-id": "new-deal-amount-status",
        marginInlineStart: "100",
        use: DEAL_HISTORY_INFO.dealAmount[AmountChangeEvent.NEW].useKeyWord,
        children: I18n.text(DEAL_HISTORY_INFO.dealAmount[AmountChangeEvent.NEW].i18nKey)
      })
    })
  });
};

/* Badge (with tooltip) that reflects a deal amount's Removed status */
export const RemovedDealAmountTag = () => {
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: DEAL_HISTORY_INFO[DEAL_AMOUNT][AmountChangeEvent.REMOVED].tooltipText
    }),
    children: /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(StatusTag, {
        "data-test-id": "removed-deal-amount-status",
        marginInlineStart: "100",
        use: DEAL_HISTORY_INFO.dealAmount[AmountChangeEvent.REMOVED].useKeyWord,
        children: I18n.text(DEAL_HISTORY_INFO.dealAmount[AmountChangeEvent.REMOVED].i18nKey)
      })
    })
  });
};
/* Badge (with tooltip) that reflects an increase or decrease in Deal Amount */
export const ChangedDealAmountTag = ({
  changePercentage
}) => {
  if (changePercentage === 0) {
    return null;
  }
  const direction = changePercentage > 0 ? AmountChangeEvent.INCREASE : AmountChangeEvent.DECREASE;
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: DEAL_HISTORY_INFO[DEAL_AMOUNT][direction].tooltipText,
      options: {
        propertyChange: I18n.formatPercentage(Math.abs(changePercentage))
      }
    }),
    children: /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(ChangeArrow, {
        "data-test-id": "deal-amount-change-arrow",
        marginInlineStart: "100",
        use: changePercentage > 0 ? 'increase' : 'decrease'
      })
    })
  });
};